import { render, staticRenderFns } from "./southport.vue?vue&type=template&id=4b903c0a&scoped=true"
import script from "./southport.vue?vue&type=script&lang=js"
export * from "./southport.vue?vue&type=script&lang=js"
import style0 from "./southport.vue?vue&type=style&index=0&id=4b903c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b903c0a",
  null
  
)

export default component.exports